/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Account_Audit_OnlineInputs */

const fr_account_audit_online = /** @type {(inputs: Account_Audit_OnlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En ligne`)
};

/**

* @param {Account_Audit_OnlineInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const account_audit_online = /** @type {((inputs?: Account_Audit_OnlineInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Account_Audit_OnlineInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_account_audit_online(inputs)
});